import Link from 'next/link';
import { BASE_API_URL,API_AUTHCODE,IMAGE_URL,SITE_URL } from '../lib/constants.js';
import axios from "axios";
import React, { useState, useEffect,useRef } from "react";
import useRedirectHandler from "../components/utils/RedirectHandler";
import Script from "next/script";

export default function Footer({ children }) {
  const [siteLogo, setSiteLogo] = useState([]);
  
  const [reloadItem, setReloadItem] = useState(0);
  const [allImages, setAllImage]=useState([]);
  const [isAlreadyImages, setIsAlreadyImages]=useState([]);
  const [footerMenuItems, setFooterItem] = useState([]);
  const [redirectHandle] = useRedirectHandler();
  // Redirect to another page
  const handleRedirect = (ele) => {
   
    redirectHandle(ele);
}
  useEffect(async() => {
    let res = await fetch(BASE_API_URL+"menus/v1/menus/3/?nested=1",{
      headers : { 
      //  'Authorization' : API_AUTHCODE,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
       
       }
     }
    ).then((res) => {
      let jsonValid = true
      Object.keys(res).forEach((key)=> {
          if(response[key] == "") {
          valid = false
        }
      });
      if(jsonValid)
      {
        return res.json();
      }
     
    }); 

    if(res)
    {  setFooterItem(res);
    }
  }, []);

  useEffect(async() => {

    let currLink= sessionStorage.getItem('currentlink');
  let currentLink = window.location.href;
  if(currLink!=currentLink)
  {
    sessionStorage.setItem('prevlink',currLink);
    sessionStorage.setItem('currentlink',currentLink);
  }

  
  }, []);
  const  getImageUrl=(imageId)=> {
    let isAlready = false;
    isAlreadyImages && isAlreadyImages.length > 0 && isAlreadyImages.map((item)=>{
      
        if(item==imageId)
        {
            isAlready = true;
        }
        
    });
    if(!isAlready)
        {
          getMediaUrlById(imageId);
        }
    let srcurl = allImages && allImages.filter((item)=>item.id==imageId);
 
    let url = srcurl && srcurl.length > 0  && srcurl[0] && srcurl[0].Url;
    return url;

  }


  async function getMedia(id)
      {
        let res = await fetch(BASE_API_URL+"wp/v2/media/"+id,{
          headers : { 
          //  'Authorization' : API_AUTHCODE,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            
           }
         }
        ).then((res) => {
          let jsonValid = true
          Object.keys(res).forEach((key)=> {
              if(response[key] == "") {
              valid = false
            }
          });
          if(jsonValid)
          {
            return res.json();
          }
         
        }); 
    
        if(res)
        { 
        let pdata = res;
        let cont = pdata?.content?.rendered;
        pdata.content = cont;
        
        let excerpt = pdata?.excerpt?.rendered;
        pdata.excerpt = excerpt;
        
        let guid = pdata?.guid?.rendered;
        pdata.guid = guid;
        
        let title = pdata?.title?.rendered;
        pdata.title = title;
        
        let newImageArray = {'id':id,"Url":pdata.guid};
        
        setAllImage((arr) => [...arr,newImageArray]);
        setReloadItem(!reloadItem);
        }
        
      }
  const getMediaUrlById=(id)=>{
   
let isAlready = false;
    isAlreadyImages && isAlreadyImages.length > 0 && isAlreadyImages.map((item)=>{
      
        if(item==id)
        {
            isAlready = true;
        }
        
    });
  
    if(!isAlready)
        {
          if(id!=null && id!=undefined && id!='')
          {
            setIsAlreadyImages((arr) => [...arr,id]);
            getMedia(id)
          }
          
        }

}
function createMarkup(html) {
  return { __html: html };
}

const getUrlSlug=(url)=>
{
return window.location.origin+''+url;
}

useEffect(() => {
  const style = document.createElement('style');
  style.id = 'cgpt-bubble-fix';
  style.innerHTML = `
    #customgpt_chat_container .cgptcb-chat-bubble {
      position: fixed !important;
      bottom: 20px !important;
      right: 20px !important;
      left: auto !important;
      z-index: 99999 !important;
      animation: cgptFloat 3s ease-in-out infinite !important;
    }

    @keyframes cgptFloat {
      0%   { transform: translateY(0px); }
      50%  { transform: translateY(-12px); }
      100% { transform: translateY(0px); }
    }
  `;
  document.head.appendChild(style);

  return () => {
    const el = document.getElementById('cgpt-bubble-fix');
    if (el) el.remove();
  };
}, []);

    return (
        <>
            <footer id="footer" className="footer">
                <div className="container pt-70 pb-40">
                    <div className="row"> 
                    <div className="col-sm-6 col-md-5">
                        <div className="widget dark">
                        <img className="img-fluid mb-20 logo" src={IMAGE_URL+"/wp-content/uploads/2023/01/cropped-logo_sub-e1673052553205.png"} alt="SDCERA footer logo"/>
                        <address className="address">2275 Rio Bonito Way, Suite 200<br/>San Diego, CA 92108</address>
                        <p className="office-timing">M-F 8:00 am - 5:00pm</p>
                        <p className="tel-nio"><a href="tel:(619) 515-6800">(619) 515-6800</a></p>
                        
                        </div>
                    </div>
                   
                    <div className="col-sm-6 col-md-4 mobile-only">
                        <div className="widget dark">
                        <p className="widget-title">Didn&apos;t find what you were looking for?</p>
                        <h4 role="presentation"><Link passHref href='/about-sdcera/satisfaction-survey'>
                          <a onClick={()=>handleRedirect("/about-sdcera/satisfaction-survey")}>
                            Leave us feedback
                            </a>
                            </Link></h4>
                        </div>
                    </div>
                   
                    <div className="col-sm-6 col-md-3">
                        <div className="widget dark">
                        <ul className="list angle-double-right list-border">
                            {footerMenuItems && footerMenuItems.length > 0 && footerMenuItems.map((menu,index)=>{
                                return (<li key={index}>
                                    <Link passHref href={menu.url}>
                                      <a onClick={()=>handleRedirect(menu.url ? menu.url :"/")}
                                         dangerouslySetInnerHTML={createMarkup(menu.title?menu.title:'#')} 
                                        />
                                    </Link>
                                    </li>)
                            })}
                        </ul>
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-4 desktop-only">
                        <div className="widget dark">
                        <p className="widget-title">Didn&apos;t find what you were looking for?</p>
                        <p className="feedback-link">
                            <Link passHref href='/about-sdcera/satisfaction-survey'>
                              <a onClick={()=>handleRedirect("/about-sdcera/satisfaction-survey")}>
                                Leave us feedback
                                </a>
                                </Link>
                        </p>
                        </div>
                    </div>
                    </div>
                </div>
                <div
                 style={{ maxHeight: "600px", overflowY: "scroll" , cursor: "pointer"}}
                  id="customgpt_chat_container"
                  role="region"
                  aria-label="AI chat"
                  tabIndex={-1}
                ></div>
                <Script
        src="https://cdn.customgpt.ai/js/chat.js"
        strategy="afterInteractive"
      />

                <Script id="customgpt-init" strategy="afterInteractive">
                 {`
                  (function(){
            function init(){
              if (typeof CustomGPT !== 'undefined') {
                CustomGPT.init({
                  p_id: '98900',
                  p_key: '9e9a852f9dfdbdecd886a69525fbab9b'
                });

                // Keep the floating bubble inside a landmark for WCAG tooling
                try {
                  var target = document.getElementById('customgpt_chat_container');
                  if (target) {
                    var moveBubble = function() {
                      var bubble = document.querySelector('.cgptcb-chat-bubble');
                      if (bubble && bubble.parentElement !== target) {
                        target.appendChild(bubble);
                      }
                    };
                    moveBubble();
                    var obs = new MutationObserver(moveBubble);
                    obs.observe(document.body, { childList: true, subtree: true });
                  }
                } catch (e) {}
              } else {
                console.error('CustomGPT library not loaded');
                // Optionally retry after a delay
                setTimeout(init, 1000);
              }
            }
            
            document.readyState === 'complete'
              ? init()
              : window.addEventListener('load', init);
          })();
        `}
      </Script>
            </footer>
           
        </>
    );
}
